import {
  Directive,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Directive({
  selector: '[appDebounceClick]',
})
export class DebounceClickDirective {
  @Input() debounceTime = 500;
  @Output() debouncedClick = new EventEmitter();

  private clicks = new Subject<void>();

  constructor() {
    this.clicks.pipe(debounceTime(this.debounceTime)).subscribe(() => {
      this.debouncedClick.emit();
    });
  }

  @HostListener('click', ['$event'])
  handleClick(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.clicks.next();
  }
}
